export default "__VITE_ASSET__ChIWXPlw__"